export type Language = "en" | "da";

export type ShiftDto = {
    shiftId: number;
    title: string;
    date: string;
    start: string;
    end: string;
    status?: string;
    functionId?: number;
    functionName?: string;
    eventId?: number;
    endsOneHourAfterPlay: boolean;
};

export type PersonDto = {
    personId: number;
    firstName: string;
    lastName: string;
};

export type EventDto = {
    eventId: number;
    eventName: string;
    infoText?: string;
};

export type TicketDto = {
    hasTicket: boolean;
    ticketID?: number;
    ticketDescription?: string;
    ticketTimeStart?: string;
    ticketTimeEnd?: string;
    active?: boolean;
    isUsed?: boolean;
    usedAt?: string | null;
    sourceType?: string;
};

export type MyShiftApiItem = {
    shiftId: number;
    functionId?: number;
    start: string;
    end: string;
    status?: string;
    title?: string;
    eventId?: number;
    functionName?: string;
    endsOneHourAfterPlay: boolean;

};

export type MyShiftResponse = {
    confirmed?: MyShiftApiItem[];
    waitlist?: MyShiftApiItem[];
    stats?: {
        confirmedCount?: number;
        waitlistCount?: number;
    };
};

export type DriverRequestDto = {
    transportRequestId: number;
    eventId: number;
    kind?: number;
    contactPerson?: string;
    contactPersonEmail?: string;
    contactPersonMobile?: string;
    numberOfPersons?: number;
    numberOfLuggage?: number;
    scheduledDate?: string;
    scheduledTime?: string;
    flightNo?: string;
    pickUpPlace?: string;
    dropOffPlace?: string;
    description?: string;
    note?: string;
    statusTransportId?: number;
    vehicleId?: number;
    vehicleName?: string;
    vehiclePlate?: string;
    currentDriverStatusId?: number;
    currentDriverStatusAt?: string;
    currentDriverStatusNote?: string;
};

export type EventFileDto = {
    fileID: number;
    eventID: number;
    eventFileSectionID?: number | null;
    name: string;
    originalFileName: string;
    sizeBytes: number;
    sortOrder: number;
    downloadUrl: string;
};

export enum Bar {
    BAR1 = 1,
    BAR2 = 2,
    BAR3 = 3,
}

export type DrinkBarStatusDto = {
    bar: number;
    functionDrinks?: number;
    personalDrinks?: number;
    totalAllowed?: number;
    usedDrinks?: number;
    remainingDrinks: number;
};

export type EventFileSectionDto = {
    eventFileSectionID: number;
    eventID: number;
    name: string;
    description?: string | null;
    sortOrder: number;
    isActive: boolean;
    isPublic: boolean;
    files: EventFileDto[];
};

export type PersonFunctionDto = {
    functionId: number;
    functionName?: string;
    eventId?: number;
};

export type FoodOrderStatusDto =
    | "Received"
    | "InProgress"
    | "Ready"
    | "Delivered"
    | "Cancelled"
    | number;

export type FoodOrderLineDto = {
    menuItemId: number;
    name: string;
    unitPrice: number;
    quantity: number;
    lineTotal: number;
};

export type FoodOrderUnitDto = {
    id: number;
    unitNumber: number;
    unitCount: number;
    menuItemId: number;
    name: string;
    status: FoodOrderStatusDto;
};

export type FoodOrderDto = {
    id: number;
    eventId: number;
    personId: number;
    personName?: string | null;
    status: FoodOrderStatusDto;
    note?: string | null;
    scheduledFor?: string | null;
    createdAt: string;
    updatedAt: string;
    total: number;
    splitOrder?: boolean;
    lines: FoodOrderLineDto[];
    units?: FoodOrderUnitDto[];
};